import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

import { filter, map } from 'rxjs/operators';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';

import { MenuHelper } from '../../common/helpers/menu.helper';
import { MenuInterface } from '../../common/interfaces/menu.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { LinkComponent } from '@gan/shared/ui-button';
import { IfHasScopeDirective } from '@gan/common/feature-auth';

@Component({
  selector: 'gan-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTabGroup, IfHasScopeDirective, MatTab, MatTabLabel, LinkComponent, RouterLink, TranslatePipe],
})
export class MenuComponent {
  private readonly router = inject(Router);

  readonly menuItems: MenuInterface[] = new MenuHelper().getMenuItems().filter((menuItem) => menuItem.display);

  private readonly url = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.router.url)
    ),
    { initialValue: this.router.url }
  );

  readonly selectedTabIndex = computed(() => {
    const url = this.url();
    const index = this.menuItems.findIndex((menuItem) => url.indexOf(menuItem.path) > -1);

    return index > -1 ? index : 0;
  });
}
